
$(document).ready(function () {

    $('.sidebar').find('li').removeClass('active');
    $('.sidebar').find('li.aboutUslink').addClass('active');


    var aboutleadership = new Swiper('.js-about-leadership', { 
        // loop: true,
        slidesPerView: 3.5,
        breakpoints: {
            320: {
                slidesPerView: 1.5,
                // spaceBetween: 25,
                // loop: true,
            },

            414: {
                slidesPerView: 2.5,
                // spaceBetween: 25,
                // loop: true,
            },

            769: {
                slidesPerView: 1,
                // loop: true,
            },
        },
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        navigation: {
            nextEl: '.swiper-button-next-team',
            prevEl: '.swiper-button-prev-team',
        },
        pagination: {
            el: '.swiper-pagination',
        },


    });

    // anoura at glance

   
    var timelineSwiper = new Swiper('.timeline .timeline-container', {
        direction: 'vertical',
        loop: false,
        speed: 1600,
        pagination: '.swiper-pagination',
        paginationBulletRender: function (swiper, index, className) {
            var year = document.querySelectorAll('.swiper-slide')[index].getAttribute('data-year');
            return '<span class="' + className + '">' + year + '</span>';
        },
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        breakpoints: {
            768: {
                direction: 'horizontal',
            }
        }
    });  

    var galleryThumbs = new Swiper(".gallery-thumbs", {
      centeredSlides: true,
      centeredSlidesBounds: false,
      slidesPerView: 6,
      spaceBetween: 0,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      direction: 'vertical',
      // loop: true,
      // autoplay: {
      //   delay:5000,
      //   disableOnInteraction: false,
      // },
      
    });
    
    var galleryMain = new Swiper(".gallery-main", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      effect: 'fade',
        fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
    
    galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumbs.slideTo(galleryMain.activeIndex);
    });
    
    galleryThumbs.on('transitionStart', function(){
      galleryMain.slideTo(galleryThumbs.activeIndex);
    });
})

// anora glance

// var timelineSwiper = new Swiper('.timeline .swiper-container', {
//     direction: 'vertical',
//     loop: false,
//     speed: 1600,
//     pagination: '.swiper-pagination',
//     paginationBulletRender: function (swiper, index, className) {
//         var year = document.querySelectorAll('.swiper-slide')[index].getAttribute('data-year');
//         return '<span class="' + className + '">' + year + '</span>';
//     },
//     paginationClickable: true,
//     nextButton: '.swiper-button-next',
//     prevButton: '.swiper-button-prev',
//     breakpoints: {
//         768: {
//             direction: 'horizontal',
//         }
//     }
// });

